<template>
  <div class="my-main-content-web">
    <div style="margin-left: 8vw; margin-right: 8vw">
      <el-row style="margin-top: 10px">
        <h3 class="text3D">
          <span @click="$routerTo('/Admin')" style="border-bottom: 1px solid;cursor: pointer;">後台設定</span>
          <span> / </span>
          <span @click="$routerTo('/AdminDocumentList')" style="border-bottom: 1px solid;cursor: pointer;">文獻管理 </span>
          <span> / </span>
          <span v-if="isEdit">文獻設定( {{ document.recno }} )</span>
          <span v-else>新增文獻</span>
        </h3>
      </el-row>

      <el-row type="flex" justify="center">
        <el-col :xs="12" :sm="6" :md="6" style>
          <span>圖片</span>
          <div class="square-img" style="text-align:left;border: 5px solid;border-color: black;">
            <img v-if="document.id.indexOf('/image/') > -1 || document.id.indexOf('base64') > -1" :src="document.id" class="image" />
            <img v-else :src="'/image/' + document.id + '_thumbnail.jpg'" class="image" />
            <!-- <img :src="document.id" /> -->
          </div>

          <el-upload action="#" list-type="picture" :on-change="selectFile" :show-file-list="false" :auto-upload="false" style="margin-top:10px">
            <el-button size="small" type="primary">選擇圖片</el-button>
          </el-upload>
        </el-col>
      </el-row>

      <!-- <el-row type="flex" justify="center">
      <el-upload
        action="#"
        list-type="picture"
        :on-change="selectFile"
        :show-file-list="false"
        :auto-upload="false"
        style="margin-top:10px"
      >
        <div class="square-img" style="text-align:left;border: 5px solid;border-color: black;">
          <img v-if="document.id.indexOf('/image/') > -1" :src="document.id" class="image" />
          <img v-else :src="'/image/' + document.id + '_thumbnail.jpg'" class="image" />
        </div>
      </el-upload>
    </el-row>-->

      <el-row type="flex" justify="center" style="margin-top: 10px">
        <el-col :xs="24" :sm="18" :md="18">
          <el-row>
            <el-col :xs="6" :sm="3" style="margin-top: 8px;"> <span style="color:red">*</span>樓層 </el-col>

            <el-col :xs="18" :sm="9">
              <el-select @change="chageFloor" v-model="selected_floor" placeholder="樓層">
                <el-option v-for="item in options_floor" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-col>

            <el-col :xs="6" :sm="3" style="margin-top: 8px;"> <span style="color:red">*</span>區域 </el-col>

            <el-col :xs="18" :sm="9">
              <el-select v-model="document.area" placeholder="區域">
                <el-option v-for="(item, index) in options_area" :key="index" :label="item['area_zh-TW']" :value="item.recno"></el-option>
              </el-select>
            </el-col>
          </el-row>

          <el-row>
            <hr />
          </el-row>

          <el-row>
            <el-col :xs="6" :sm="3" style="margin-top: 8px;"> <span style="color:red">*</span>品名 </el-col>

            <el-col :xs="18" :sm="9">
              <el-input v-model="document['name_zh-TW']" placeholder="品名"></el-input>
            </el-col>

            <el-col :xs="6" :sm="3" style="margin-top: 8px;">年代</el-col>

            <el-col :xs="18" :sm="9">
              <el-input v-model="document.year" placeholder="年代"></el-input>
            </el-col>

            <el-col :xs="6" :sm="3" style="margin-top: 8px;">捐贈者</el-col>

            <el-col :xs="18" :sm="9">
              <el-input v-model="document['donor_zh-TW']" placeholder="捐贈者"></el-input>
            </el-col>

            <el-col :xs="6" :sm="3" style="margin-top: 8px;">捐贈日期</el-col>

            <el-col :xs="18" :sm="9">
              <el-input v-model="document.donor_date" placeholder="捐贈日期"></el-input>
            </el-col>
          </el-row>

          <el-row>
            <hr />
          </el-row>

          <el-row>
            <el-col :xs="6" :sm="3" style="margin-top: 8px;">長(mm)</el-col>

            <el-col :xs="18" :sm="9">
              <el-input v-model="document.length" placeholder="長(mm)"></el-input>
            </el-col>

            <el-col :xs="6" :sm="3" style="margin-top: 8px;">寬(mm)</el-col>

            <el-col :xs="18" :sm="9">
              <el-input v-model="document.width" placeholder="寬(mm)"></el-input>
            </el-col>

            <el-col :xs="6" :sm="3" style="margin-top: 8px;">高(mm)</el-col>

            <el-col :xs="18" :sm="9">
              <el-input v-model="document.height" placeholder="高(mm)"></el-input>
            </el-col>

            <el-col :xs="6" :sm="3" style="margin-top: 8px;">重量(g)</el-col>

            <el-col :xs="18" :sm="9">
              <el-input v-model="document.weight" placeholder="重量(g)"></el-input>
            </el-col>
          </el-row>

          <el-row>
            <hr />
          </el-row>

          <el-row>
            <el-col :xs="6" :sm="3" style="margin-top: 8px;">地點</el-col>

            <el-col :xs="18" :sm="9">
              <el-input v-model="document['location_zh-TW']" placeholder="地點"></el-input>
            </el-col>

            <el-col :xs="6" :sm="3" style="margin-top: 8px;">檔名</el-col>

            <el-col :xs="18" :sm="9">
              <el-input v-model="document.doc" placeholder="檔名"></el-input>
            </el-col>
          </el-row>

          <el-row>
            <hr />
          </el-row>

          <el-row>
            <el-col :span="24" style="margin-top: 8px;">產品介紹</el-col>

            <el-col :span="24">
              <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6 }" placeholder="產品介紹" v-model="document['description_zh-TW']"></el-input>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <hr />

      <el-button @click="translate()" type="warning" size="sm">多國語言翻譯</el-button>
      <el-row justify="center" style="margin-top: 10px">
        <el-col :span="12">
          <h4>簡體</h4>
          <el-row>
            <el-col :span="6" style="margin-top: 8px;">品名</el-col>

            <el-col :span="18">
              <el-input v-model="document['name_zh-CN']" placeholder="品名"></el-input>
            </el-col>

            <el-col :span="6" style="margin-top: 8px;">捐贈者</el-col>

            <el-col :span="18">
              <el-input v-model="document['donor_zh-CN']" placeholder="捐贈者"></el-input>
            </el-col>

            <el-col :span="6" style="margin-top: 8px;">地點</el-col>

            <el-col :span="18">
              <el-input v-model="document['location_zh-CN']" placeholder="地點"></el-input>
            </el-col>

            <el-col :span="6" style="margin-top: 8px;">產品介紹</el-col>

            <el-col :span="18">
              <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6 }" placeholder="產品介紹" v-model="document['description_zh-CN']"></el-input>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="12">
          <h4>英語</h4>
          <el-row>
            <el-col :span="6" style="margin-top: 8px;">品名</el-col>

            <el-col :span="18">
              <el-input v-model="document['name_en']" placeholder="品名"></el-input>
            </el-col>

            <el-col :span="6" style="margin-top: 8px;">捐贈者</el-col>

            <el-col :span="18">
              <el-input v-model="document['donor_en']" placeholder="捐贈者"></el-input>
            </el-col>

            <el-col :span="6" style="margin-top: 8px;">地點</el-col>

            <el-col :span="18">
              <el-input v-model="document['location_en']" placeholder="地點"></el-input>
            </el-col>

            <el-col :span="6" style="margin-top: 8px;">產品介紹</el-col>

            <el-col :span="18">
              <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6 }" placeholder="產品介紹" v-model="document['description_en']"></el-input>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="12">
          <h4>韓語</h4>
          <el-row>
            <el-col :span="6" style="margin-top: 8px;">品名</el-col>

            <el-col :span="18">
              <el-input v-model="document['name_ko']" placeholder="品名"></el-input>
            </el-col>

            <el-col :span="6" style="margin-top: 8px;">捐贈者</el-col>

            <el-col :span="18">
              <el-input v-model="document['donor_ko']" placeholder="捐贈者"></el-input>
            </el-col>

            <el-col :span="6" style="margin-top: 8px;">地點</el-col>

            <el-col :span="18">
              <el-input v-model="document['location_ko']" placeholder="地點"></el-input>
            </el-col>

            <el-col :span="6" style="margin-top: 8px;">產品介紹</el-col>

            <el-col :span="18">
              <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6 }" placeholder="產品介紹" v-model="document['description_ko']"></el-input>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="12">
          <h4>日語</h4>
          <el-row>
            <el-col :span="6" style="margin-top: 8px;">品名</el-col>

            <el-col :span="18">
              <el-input v-model="document['name_ja']" placeholder="品名"></el-input>
            </el-col>

            <el-col :span="6" style="margin-top: 8px;">捐贈者</el-col>

            <el-col :span="18">
              <el-input v-model="document['donor_ja']" placeholder="捐贈者"></el-input>
            </el-col>

            <el-col :span="6" style="margin-top: 8px;">地點</el-col>

            <el-col :span="18">
              <el-input v-model="document['location_ja']" placeholder="地點"></el-input>
            </el-col>

            <el-col :span="6" style="margin-top: 8px;">產品介紹</el-col>

            <el-col :span="18">
              <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6 }" placeholder="產品介紹" v-model="document['description_ja']"></el-input>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row style="margin-left:20px;margin-top: 30px;margin-bottom: 30px">
        <el-col :span="24">
          <el-button v-if="isEdit" @click="editDocument()" type="primary">修改</el-button>
          <el-button v-else @click="postDocument()" type="success">新增</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { tify, sify } from "chinese-conv";
import { loadFileToBase64, loadBase64ToImage, base64ToFile, compressImagetoBase64 } from "../plugins/upload_image";

let form_data;

export default {
  name: "home",
  data() {
    return {
      options_floor: ["1", "2", "3"],
      selected_floor: "",
      options_area: [],
      document: {
        img: "",
        "location_zh-TW": "",
        "location_zh-CN": "",
        location_en: "",
        location_ko: "",
        location_ja: "",
        area: "",
        "donor_zh-TW": "",
        "donor_zh-CN": "",
        donor_en: "",
        donor_ko: "",
        donor_ja: "",
        donor_date: "",
        year: "",
        recno: "",
        "name_zh-TW": "",
        "name_zh-CN": "",
        name_en: "",
        name_ko: "",
        name_ja: "",
        width: "",
        length: "",
        doc: "",
        id: "",
        floor: "",
        height: "",
        weight: "",
        "description_zh-TW": "",
        "description_zh-CN": "",
        description_en: "",
        description_ko: "",
        description_ja: ""
      },
      isEdit: true
    };
  },
  async mounted() {
    this.$store.commit("set_page", location.hash);

    form_data = new FormData();

    this.$store.commit("setLoadingMask", true);

    let areas = JSON.parse(localStorage.getItem("areas"));

    if (this.$route.params.recno == 0) {
      this.isEdit = false;
    } else {
      await axios
        .get("/api/adminDoc?recno=" + this.$route.params.recno)
        .then(response => {
          areas.forEach(element => {
            if (element.recno == response.data.data[0].area) {
              this.chageFloor(element.floor);
              this.selected_floor = element.floor;
            }
          });
          for (let key in response.data.data[0]) {
            this.document[key] = response.data.data[0][key];
          }

          this.document.area = parseInt(response.data.data[0].area);
        })
        .catch(error => {
          console.log(error.message);
        });
    }

    this.$store.commit("setLoadingMask", false);
  },
  methods: {
    async selectFile(file, fileList) {
      console.log(file);
      let filename = file.name;

      let base64 = await loadFileToBase64(file.raw);
      let img = await loadBase64ToImage(base64);
      let new_base64 = compressImagetoBase64(img);
      let new_file = base64ToFile(new_base64, filename);

      this.document.id = new_base64;

      console.log(new_file);
      form_data.set("img", new_file);
    },
    async postDocument() {
      if (!this.document.area || !this.document["name_zh-TW"]) {
        this.$message.warning("必填欄位，不可空白！");
        return false;
      }

      this.$store.commit("setLoadingMask", true);

      // 上傳圖片
      if (form_data.getAll("img").length > 0) {
        let res = await this.$uploadFile(form_data);
        if (res) {
          let img_url = "/image/" + res[form_data.get("img").name];
          this.document.img = img_url;
        } else {
          this.$message.warning("圖片上傳失敗，請檢查");
        }
      }

      delete this.document.recno;

      await axios
        .post("/api/adminDoc", this.document)
        .then(response => {
          console.log(response);
          this.$routerTo("/Admin");
          this.$message.success("新增成功");

          this.$getArea();
        })
        .catch(error => {
          console.log(error.message);
        });

      this.$store.commit("setLoadingMask", false);
    },
    async editDocument() {
      if (!this.document.area || !this.document["name_zh-TW"]) {
        this.$message.warning("必填欄位，不可空白！");
        return false;
      }

      this.$store.commit("setLoadingMask", true);

      // 上傳圖片
      if (form_data.getAll("img").length > 0) {
        let res = await this.$uploadFile(form_data);
        if (res) {
          let img_url = "/image/" + res[form_data.get("img").name];
          this.document.img = img_url;
        } else {
          this.$message.warning("圖片上傳失敗，請檢查");
        }
      }

      await axios
        .put("/api/adminDoc/" + this.document.recno, this.document)
        .then(response => {
          console.log(response);
          this.$routerTo("/Admin");
          this.$message.success("修改成功");

          this.$getArea();
        })
        .catch(error => {
          console.log(error.message);
        });
      this.$store.commit("setLoadingMask", false);
    },
    chageFloor(val) {
      let areas = JSON.parse(localStorage.getItem("areas"));

      if (val == "1") {
        this.options_area = areas.filter(el => {
          return el.floor == 1;
        });
      } else if (val == "2") {
        this.options_area = areas.filter(el => {
          return el.floor == 2;
        });
      } else if (val == "3") {
        this.options_area = areas.filter(el => {
          return el.floor == 3;
        });
      }
    },
    async translate() {
      if (!this.document.area || !this.document["name_zh-TW"]) {
        this.$message.warning("必填欄位，不可空白！");
        return false;
      }

      this.$store.commit("setLoadingMask", true);

      this.document["name_zh-CN"] = sify(this.document["name_zh-TW"]);
      this.document["donor_zh-CN"] = sify(this.document["donor_zh-TW"]);
      this.document["location_zh-CN"] = sify(this.document["location_zh-TW"]);
      this.document["description_zh-CN"] = sify(this.document["description_zh-TW"]);

      let api_key = "AIzaSyDvidOES_35o1dylx-03Y8_9XGvNviN9oY";
      let text_en = "&q=" + this.document["name_zh-TW"] + "&q=" + this.document["donor_zh-TW"] + "&q=" + this.document["location_zh-TW"] + "&q=" + this.document["description_zh-TW"];
      function getTranslateEn() {
        return axios.get("https://translation.googleapis.com/language/translate/v2?key=" + api_key + text_en + "&target=en&source=zh&format=text");
      }
      let text_ko = "&q=" + this.document["name_zh-TW"] + "&q=" + this.document["donor_zh-TW"] + "&q=" + this.document["location_zh-TW"] + "&q=" + this.document["description_zh-TW"];
      function getTranslateKo() {
        return axios.get("https://translation.googleapis.com/language/translate/v2?key=" + api_key + text_ko + "&target=ko&source=zh&format=text");
      }
      let text_ja = "&q=" + this.document["name_zh-TW"] + "&q=" + this.document["donor_zh-TW"] + "&q=" + this.document["location_zh-TW"] + "&q=" + this.document["description_zh-TW"];
      function getTranslateJa() {
        return axios.get("https://translation.googleapis.com/language/translate/v2?key=" + api_key + text_ja + "&target=ja&source=zh&format=text");
      }

      await Promise.all([getTranslateEn(), getTranslateKo(), getTranslateJa()]).then(results => {
        console.log(results);
        this.document["name_en"] = results[0].data.data.translations[0].translatedText;
        this.document["name_ko"] = results[1].data.data.translations[0].translatedText;
        this.document["name_ja"] = results[2].data.data.translations[0].translatedText;

        this.document["donor_en"] = results[0].data.data.translations[1].translatedText;
        this.document["donor_ko"] = results[1].data.data.translations[1].translatedText;
        this.document["donor_ja"] = results[2].data.data.translations[1].translatedText;

        this.document["location_en"] = results[0].data.data.translations[2].translatedText;
        this.document["location_ko"] = results[1].data.data.translations[2].translatedText;
        this.document["location_ja"] = results[2].data.data.translations[2].translatedText;

        this.document["description_en"] = results[0].data.data.translations[3].translatedText;
        this.document["description_ko"] = results[1].data.data.translations[3].translatedText;
        this.document["description_ja"] = results[2].data.data.translations[3].translatedText;
      })
      .catch(e => {
        console.log(e)
        this.$message.warning("翻譯時似乎出了點問題，請聯繫開發人員！");
      })
      .finally(()=>{
        this.$store.commit("setLoadingMask", false);
      });
    }
  }
};
</script>

<style scoped>
.square-img {
  width: 100%;
  height: 0px;
  padding-bottom: 100%;
  position: relative;
}
.square-img img {
  width: 100%;
  height: 100%;
  position: absolute;
}

.list-section h1 {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #4f4f4f;
  line-height: 1px;
  margin: 60px 0 14px;
  font-weight: bold;
  font-size: 26px;
}
</style>
